import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
import user from './user'
import auth from './auth'
import job from './job'
import transaction from './transaction'
import demo from './demo'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    user,
    job,
    transaction,
    demo,
    {
      path: '/',
      name: 'home',
      meta: { headerInvert: true, mayRequireAuth: true },
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue')
    },
    {
      path: '/index.html',
      name: 'pwa',
      meta: { headerInvert: true, mayRequireAuth: true },
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue')
    },
    {
      path: '/tools',
      name: 'search',
      meta: { headerInvert: true, mayRequireAuth: true },
      component: () =>
        import(/* webpackChunkName: "search-page" */ '@/views/SearchPage.vue')
    },
    {
      path: '/faq',
      name: 'faq',
      meta: { mayRequireAuth: true },
      component: () =>
        import(/* webpackChunkName: "faq-page" */ '@/views/FAQPage.vue')
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      meta: { mayRequireAuth: true },
      component: () =>
        import(
          /* webpackChunkName: "privacy-policy-page" */ '@/views/PrivacyPolicyPage.vue'
        )
    },
    {
      path: '/terms-and-conditions',
      name: 'terms-and-conditions',
      meta: { mayRequireAuth: true },
      component: () =>
        import(
          /* webpackChunkName: "terms-and-conditions-page" */ '@/views/TermsAndConditionsPage.vue'
        )
    },

    {
      path: '/service-unavailable',
      name: 'service-unavailable',
      meta: { mayRequireAuth: true },
      component: () =>
        import(
          /* webpackChunkName: "service-unavailable" */ '@/views/error/ServiceUnavailable.vue'
        )
    },
    {
      path: '*',
      name: 'page-not-found',
      meta: { mayRequireAuth: true },
      component: () =>
        import(
          /* webpackChunkName: "page-not-found" */ '@/views/error/PageNotFound.vue'
        )
    }
  ]
})

router.afterEach((to, from) => {
  /* Check for alert/flash message */
  if (to.params.alert) {
    store.dispatch('alert/addAlert', to.params.alert)
  }
})

export default router
